import * as React from "react";
import "./Card.css";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from "../../i18n/custom.i18n";
import { LazyLoadImageCDN } from "./CDNImage";

import { OverlayContainer } from "./CardStylings";
import { station_name } from "./../Details/description-station-name";

export const StationCard = (data: any) => {
    const { t, i18n } = useTranslation();

    const [OverlayDisplay, setOverlayDisplay] = React.useState("none");
    const overlayHeightRef = React.useRef("auto");

    // TODO: Move to .init( ? this won't change
    //var robodk_web_open = window.Paths.ROBODK_WEB_OPEN_CDN ? window.Paths.ROBODK_WEB_OPEN_CDN + "/downloads-library/library-stations/" : window.Paths.ROBODK_WEB_OPEN + "/library-stations/lib/";
        var lang_add = "";
    if (window.Languages.language != "en"){
        lang_add = window.Languages.language + "/";
    }
    var robodk_web_open = window.Paths.ROBODK_WEB_3D + lang_add + "example/" + data.file;
    if (robodk_web_open.endsWith(".rdk")){
        robodk_web_open = robodk_web_open.slice(0, -4);
    }

    let showDetails = true;
    //console.log(data)

    
    let name = data.file.split(".", 1)[0];
    let item = {"AP": data.applications, "RN": data.robots, "T": data.tags, "TCM": data.tcm};
    let name_tr = station_name(item, t);

    let DetailsURL = window.Paths.HOST_DETAILS;
    if (window.Settings.LOCAL_BUILD) {
        switch (window.Languages.language) {
            case "en":
                DetailsURL += window.Paths.DETAILS_URL + "station=" + name;
                break;

            default:
                DetailsURL += window.Paths.DETAILS_URL + "Lang=" + window.Languages.language + "&" + "station=" + name;
                break;
        }
    } else {
        switch (window.Languages.language) {
            case "en":
                DetailsURL += "/example/" + name;
                break;

            default:
                DetailsURL += "/example/" + window.Languages.language + "/" + name;
                break;
        }
    }

    return (
        <div id={name} className="library-robot-container">
            <div
                className="library-robot"
                onMouseEnter={(e: React.MouseEvent) => {
                    if (OverlayDisplay === "none") {
                        let station_title = e.currentTarget.childNodes[0] as HTMLHeadingElement;
                        let station_image = e.currentTarget.childNodes[1] as HTMLDivElement;
                        let image_padding = 17;

                        overlayHeightRef.current = (station_title.clientHeight + station_image.clientHeight + image_padding).toString();

                        setOverlayDisplay("flex");
                    }
                }}
                onMouseLeave={(e: React.MouseEvent) => setOverlayDisplay("none")}
            >
                <h6 className="robot-title">{name_tr}</h6>
                <div className="image-box-station">
                    <LazyLoadImageCDN 
                        cdnPath={window.Paths.ROBODK_CDN + window.Paths.FOLDER_STATIONS_IMG_CDN + data.img}
                        localPath={window.Paths.FOLDER_STATIONS_IMG + data.img}
                        alt={name_tr}
                        libAssetsPath={window.Paths.STATION_LIB_ASSETS}
                        classname={"img-robot"}
                    />
                </div>

                {showDetails && (
                    <table className="table table-striped">
                        <tbody>
                            {data.applications.length > 0 &&
                                <tr>
                                    <td>{t('filters-stations.applications')}</td>
                                    <td>{data["applications"].map((application) => t('application.' + application)).join(", ")}</td>
                                </tr>
                            }
                            {data.tags.length > 0 &&
                                <tr>
                                    <td>{t('filters-stations.tags')}</td>
                                    <td>{data["tags"].map((tag) => t('tags-station.' + tag)).join(", ")}</td>
                                </tr>
                            }
                            {data.brands.length > 0 &&
                                <tr>
                                    <td>{t('filters-stations.brand')}</td>
                                    <td>{data.brands.join(", ")}</td>
                                </tr>
                            }
                            {data.mechanism_types.length > 0 &&
                                <tr>
                                    <td>{t('filters-stations.mechanism-type')}</td>
                                    <td>{data["mechanism_types"].map((type) => t('item-types.' + type)).join(", ")}</td>
                                </tr>
                            }
                            {data.robots.length > 0 &&
                                <tr>
                                    <td>{t('filters-stations.robot-names')}</td>
                                    <td>{data.robots.join(", ")}</td>
                                </tr>
                            }
                            {data.axis_counts.length > 0 && (
                                <tr>
                                    <td>{t('filters-stations.axes-names')}</td>
                                    <td>{data.axis_counts.join(", ")}</td>
                                </tr>
                            )}
                            {data.tool_counts.length > 0 &&
                                <tr>
                                    <td>{t('filters-stations.tool-names')}</td>
                                    <td>{data.tool_counts.join(", ")}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                )}
            </div>

            <OverlayContainer
                key={"overlay-" + data.name}
                height={overlayHeightRef.current}
                display={OverlayDisplay}
            >
                <div className="robot-links">
                    {window.Settings.open_in_rdk &&
                        <div
                            onClick={(e) => window.get_lib(true, data.file, "station")}
                            role="button"
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardOpenBtn')}</strong>
                        </div>
                    }
                    {
                        <a
                            href={DetailsURL} 
                            // onClick={(e) => window.open(DetailsURL, "_blank")}
                            target="_blank"
                            type="button"
                            role="button"
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardDetailsBtn')}</strong>
                        </a>
                    }
                    {!window.Settings.on_robodk_web &&
                        <a
                            href={robodk_web_open}
                            target="_blank"
                            type="button"
                            role="button"
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardView3DBtn')}</strong>
                        </a>
                    }
                    {
                        <div
                            onClick={(e) => window.get_lib(false, data.file, "station")}
                            role="button"
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardDownloadBtn')}</strong>
                        </div>
                    }
                </div>
            </OverlayContainer>
        </div>
    )
}
